import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import LuciPropTypes from "../../propTypes";
import { actions as runningOrderActions } from "../../actions/runningOrder";
import { Select } from "../../styled-components/";
import {
  ControlBarContainer,
  ControlList,
  ControlListItem
} from "../../styled-components/ControlBar";
import localize from "../../util/localizeUtils";

const ReloadButton = styled.img`
  height: 16px;
`;

const RunningOrderControlBarContainer = styled(ControlBarContainer)`
  margin-bottom: 2rem;
`;

class ControlBar extends React.Component {
  onRunningOrderSelect = event => {
    this.props.getRunningOrder(event.target.value);
  };
  renderReloadButton() {
    const { getRunningOrder, selectedRunningOrder } = this.props;
    return selectedRunningOrder !== "-1" ? (
      <ControlListItem>
        <ReloadButton
          src="images/reload.png"
          onClick={() => getRunningOrder(selectedRunningOrder)}
        />
      </ControlListItem>
    ) : null;
  }
  render() {
    const { runningOrdersList, selectedRunningOrder } = this.props;
    const runningOrdersSelectList = runningOrdersList
      ? runningOrdersList.map(r => (
          <option key={r.id} value={r.id}>
            {r.name}
          </option>
        ))
      : [];
    runningOrdersSelectList.unshift(
      <option key={-1} value={-1} disabled>
        {localize("selectRunningOrderOption")}
      </option>
    );
    return (
      <RunningOrderControlBarContainer>
        <ControlList>
          <ControlListItem>
            <Select
              id="running-order-select"
              defaultValue={selectedRunningOrder}
              onChange={this.onRunningOrderSelect}
            >
              {runningOrdersSelectList}
            </Select>
          </ControlListItem>
          {this.renderReloadButton()}
        </ControlList>
      </RunningOrderControlBarContainer>
    );
  }
}

ControlBar.defaultProps = {
  runningOrdersList: [],
  selectedRunningOrder: "-1"
};

ControlBar.propTypes = {
  runningOrdersList: LuciPropTypes.RunningOrderList,
  selectedRunningOrder: PropTypes.string,
  getRunningOrder: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  runningOrdersList: state.runningOrder.runningOrdersList,
  selectedRunningOrder: state.runningOrder.runningOrder.id
    ? state.runningOrder.runningOrder.id
    : "-1"
});

const mapActionCreators = {
  getRunningOrder: runningOrderActions.getRunningOrder
};

export default connect(mapStateToProps, mapActionCreators)(ControlBar);



// WEBPACK FOOTER //
// ./app/components/RunningOrders/ControlBar.js